export const PARENTS = 'md_parents_GLOBAL';